
import MdContent from 'components/md-content'
import MeetingInfo from './meeting-info.vue'

export default {
  components: {MdContent, MeetingInfo},
  props: {
    meeting: {type: Object, required: true},
    loading: {type: Boolean, default: false},
    idx: {type: Number, required: true},
    readonly: {type: Boolean, default: false},
  },
  computed: {
    info() {
      return this.meeting.info
    },
    sections() {
      return this.meeting.sections
    },
    markdown(){
      return this.meeting.markdown
    }
  },
  methods: {
    save(ext){
      this.$dispatch('document-save', {
        card_idx: this.idx,
        ext
      })
    },
  }
}
